module.exports = __webpack_public_path__ + "static/media/gada.0ef0fb0f.jpeg";